export default function Footer() {
  return (
    <footer id="footer" className="bg-background-900 border-t border-background-800/40">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 md:gap-12">

          {/* Brand */}
          <div className="lg:col-span-1">
            <a href="#hero" className="flex items-center gap-2 mb-4 whitespace-nowrap cursor-pointer">
              <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500 text-background-950 font-heading font-bold text-lg leading-none">
                91
              </span>
              <span className="text-foreground-100 font-heading text-xl font-bold tracking-wide">
                黑料
              </span>
            </a>
            <p className="text-sm text-foreground-500 leading-relaxed mt-3">
              91黑料吃瓜网——最新娱乐八卦与黑料事件聚集地，提供91黑料吃瓜在线围观，黑料吃瓜爆料不停。第一时间吃瓜黑料，娱乐围观不迷路。
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-foreground-200 font-heading font-semibold text-sm mb-4">
              快速导航
            </h4>
            <div className="flex flex-col gap-2.5">
              {[
                { label: '焦点专题', href: '#carousel' },
                { label: '黑料深扒', href: '#cards' },
                { label: '热门话题', href: '#topics' },
                { label: '最新快讯', href: '#updates' },
                { label: '热度榜单', href: '#ranking' },
              ].map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  className="text-sm text-foreground-500 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap cursor-pointer"
                >
                  {link.label}
                </a>
              ))}
            </div>
          </div>

          {/* Service */}
          <div>
            <h4 className="text-foreground-200 font-heading font-semibold text-sm mb-4">
              平台服务
            </h4>
            <div className="flex flex-col gap-2.5">
              {[
                { label: '吃瓜问答', href: '#faq' },
                { label: '视频专区', href: '#media' },
                { label: '专题索引', href: '#index' },
                { label: '联系我们', href: '#contact' },
                { label: '关于我们', href: '#about' },
              ].map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  className="text-sm text-foreground-500 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap cursor-pointer"
                >
                  {link.label}
                </a>
              ))}
            </div>
          </div>

          {/* Partners */}
          <div>
            <h4 className="text-foreground-200 font-heading font-semibold text-sm mb-4">
              合作伙伴
            </h4>
            <p className="text-sm text-foreground-600 leading-relaxed">
              更多合作伙伴即将入驻，敬请期待。
            </p>
          </div>
        </div>

        {/* Bottom */}
        <div className="mt-12 pt-6 border-t border-background-800/30 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-600">
            &copy; {new Date().getFullYear()} 91黑料吃瓜网. 本站内容仅供娱乐围观，请理性吃瓜。
          </p>
          <p className="text-xs text-foreground-700">
            黑料吃瓜爆料不停 · 娱乐八卦在线围观
          </p>
        </div>
      </div>
    </footer>
  );
}